import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { APIError } from "@/adapters/api";
import { OtdLogo } from "@/components/layout/otd-logo";
import { LoginForm } from "@/features/auth/components/login-form";
import { ResendVerificationAction } from "@/features/auth/components/resend-verification-action";
import { SocialPanel } from "@/features/auth/components/social-panel";
import { useLogin } from "@/features/auth/hooks/use-login";
import type { LoginFormValues } from "@/features/auth/schemas/login-schema";

export function LoginPage() {
	const navigate = useNavigate();
	const login = useLogin();
	const [error, setError] = useState("");
	const [unverifiedEmail, setUnverifiedEmail] = useState("");

	function handleLogin(values: LoginFormValues) {
		setError("");
		setUnverifiedEmail("");
		login.mutate(values, {
			onSuccess: ({ needsOnboarding }) => {
				navigate(needsOnboarding ? "/onboarding" : "/", { replace: true });
			},
			onError: (err) => {
				if (err instanceof APIError) {
					if (
						err.code === "email-not-verified" ||
						err.reason === "email-not-verified"
					) {
						setError("Confirme seu e-mail para entrar.");
						setUnverifiedEmail(values.email);
						return;
					}
					if (err.code === "invalid_credentials") {
						setError("E-mail ou senha incorretos.");
						return;
					}
				}
				setError(
					"Não foi possível entrar. Verifique sua conexão e tente novamente.",
				);
			},
		});
	}

	function handleForgotPassword() {
		navigate("/forgot-password");
	}

	return (
		<div className="login-page">
			<div className="login-page__main">
				<div className="login-page__brand-row">
					<Link to="/" className="login-page__brand">
						<OtdLogo className="login-page__brand-logo" />
						Obra Todo Dia
					</Link>
				</div>
				<div className="login-page__content">
					<div className="login-page__panel">
						<LoginForm
							loading={login.isPending}
							error={error}
							errorAction={
								unverifiedEmail ? (
									<ResendVerificationAction email={unverifiedEmail} />
								) : undefined
							}
							onSubmit={handleLogin}
							onForgotPassword={handleForgotPassword}
						/>
						<p className="login-page__footer">
							Não tem uma conta?{" "}
							<Link to="/onboarding" className="login-page__footer-link">
								Criar conta
							</Link>
						</p>
					</div>
				</div>
			</div>
			<SocialPanel />
		</div>
	);
}
